import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sticky-top d-flex justify-content-between py-4 px-5" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex" }

import ReturnButton from "./buttons/ReturnButton.vue";
import UserMenuButton from "./dropdown/UserMenuButton.vue";
import NotifyButton from "./buttons/NotifyButton.vue";
import DialogContiainer from "../dialog/DialogsContainer.vue";
import FileMenuButtons  from "./dropdown/FileMenuButtons.vue"
import { useRoute, useRouter } from 'vue-router';
import { backToBlocklyPage } from "../../pages/files/functional/backToBlocklyPage";

interface Prop {
  backTo: ()=>void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OptionPageHeader',
  props: {
    backTo: null
  },
  setup(__props: any) {

const props = __props as {
  backTo: ()=>void
};

const route = useRoute();
const router = useRouter();



 

const toOriginPage = ()=>{
  const project_id = route.params.project_id;
  if(!project_id ||project_id === "no_project_id" ){
    router.push({name:"ListPage"})
  } else {
    if (props.backTo) {
      props.backTo();
    } else {
      backToBlocklyPage(route,router);
      
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(ReturnButton, { "on-click-delegate": toOriginPage })
      ]),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(NotifyButton),
        _createVNode(FileMenuButtons, { class: "mt-1" }),
        _createVNode(UserMenuButton, { class: "mt-1" })
      ])
    ]),
    _createVNode(DialogContiainer)
  ], 64))
}
}

})